import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';

import { Typography } from '@mui/material';
import { BrandCode } from 'types';

export const Container = styled.div`
	display: inline-flex;
	margin-right: 30px;
	align-items: baseline;

	@media (max-width: ${sizes.media.smallMaxWidth}px) {
		margin: 0;
		flex-direction: row;
		justify-content: space-between;
		align-items: baseline;
		width: 100%;
		margin-block: 4px;

		& button {
			padding: 3px 0px;
		}
	}
`;

export const Label = styled(Typography)`
	color: ${colors.rccl.lavelResultsHeader};
	min-width: max-content;
	margin-right: 6px !important;
	&& span {
		${({ styles }) => styles}
		${({ theme }) =>
			({
				[BrandCode.RoyalCaribbean]: `
        font-family: ${theme.typography.fontFamilySemiBold};
        `,
			})[theme.brandCode]}
	}
`;
